if(!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.observer = new IntersectionObserver(this.setMenuTopPosition).observe(this);
    }

    setMenuTopPosition([entry], observer) {
      const root = document.documentElement.style;
      root.setProperty('--header-menu-top', entry.isIntersecting ? 'var(--announcement-bar)' : '0px');
    }
  }

  customElements.define('announcement-bar', AnnouncementBar)
}